export const openingHourRoutes = {
	openingHours: '/settings/business_days/',
	openingHour: (id: string) => `/settings/business_days/${id}/`
} as const
